<template>
  <div style="margin: 20px 10px;">
    <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
    >
      <el-table-column prop="order_sn" label="所属订单" width="180"/>
      <el-table-column prop="country" label="所属国家" width="80"/>
      <el-table-column prop="ip_address" label="ip地址"/>
      <el-table-column prop="port" label="端口"/>
      <el-table-column prop="proxy_username" label="用户名"/>
      <el-table-column prop="proxy_password" label="密码"/>
      <el-table-column prop="create_time" label="创建时间" width="160"/>
      <el-table-column prop="end_time" label="到期时间" width="160"/>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="fetchData"
    />

  </div>
</template>

<script>
import api from "@/requset/api";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    refresh() {
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      api.ip_resource_list({
        page: this.page,
        pageSize: this.pageSize
      })
          .then((res) => {
            this.loading = false;
            if (res.data.error_code != 0) {
              this.$message({
                message: res.data.message,
                type: "warning",
              });
              return
            }
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          })
          .catch(() => {
            this.loading = false;
          });
    },
  }
}
</script>
